import { createFileRoute } from "@tanstack/react-router";
import FreeConsultation from "@/pages/site/FreeConsultation";

export const Route = createFileRoute("/free-consultation")({
  component: () => <FreeConsultation />,
});
